import { useCallback, useRef } from 'react';

/**
 * Returns a function whose identity never changes but always calls the latest `fn`.
 * Lets memoized children take handlers that close over fresh state without re-rendering.
 */
export function useStableCallback(fn) {
  const ref = useRef(fn);
  ref.current = fn;
  return useCallback((...args) => ref.current(...args), []);
}
